<template>
  <div class="autocomplete">
    <div class="SearchBar" v-bind:class="{ openSuggestions: isOpen }">
      <b-icon-search variant="white" class="SearchIcon"></b-icon-search>
      <b-form-input
        type="text"
        v-model="search"
        @input="onChange"
        id="SearchInput"
        placeholder="global search"
        autocomplete="off"
        @focus="handleFocus"
        @blur="handleBlur"
      />
    </div>
    <ul v-show="isOpen" class="pl-0 suggestions" v-if="results.length > 0">
      <li v-for="(result, i) in results" :key="i" class="autocomplete-result">
        <div id="suggestionRow" @mousedown.prevent="suggestionClick(result)">
          <template v-if="error"> </template>

          <b-row>
            <b-col cols="1" class="my-auto">
              <b-img :src="result.icon" width="25%" height="25%"></b-img>
            </b-col>
            <b-col>
              {{ result.name }}
              <template v-if="result.gemIsCorrupted">
                <b-img
                  src="https://web.poecdn.com/gen/image/WzI1LDE0LHsiZiI6IjJESXRlbXMvQ3VycmVuY3kvQ3VycmVuY3lWYWFsIiwidyI6MSwiaCI6MSwic2NhbGUiOjF9XQ/304f775089/CurrencyVaal.png"
                  height="22"
                  width="18"
                ></b-img>
              </template>
              <br />
              {{ result.mean }}
              <b-img
                src="https://web.poecdn.com/image/Art/2DItems/Currency/CurrencyRerollRare.png?v=c60aa876dd6bab31174df91b1da1b4f9"
                height="22"
                width="18"
              ></b-img>
            </b-col>
          </b-row>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "autocomplete",
  data() {
    return {
      search: "",
      results: [],
      isOpen: false,
      items: [],
      maxAmount: 20,
      error: false,
      current: 0,
    };
  },
  props: {
    league: String,
  },
  mounted() {
    axios
      .get("https://api.poe.watch/search?league=" + this.league)
      .then((response) => {
        this.items = response.data;
      });
  },
  methods: {
    onChange() {
      this.isOpen = true;
      this.filterResults();
    },
    handleFocus() {
      if (this.search.length > 0) {
        this.isOpen = true;
      }
    },
    handleBlur() {
      this.isOpen = false;
    },
    suggestionClick(item) {
      this.search = "";
      this.$router.push({ path: `/detailed/${item.id}` });
      this.isOpen = false;
    },
    filterResults() {
      let amount = 0;
      let filteredItems = [];
      for (let i = 0; i < this.items.length; i++) {
        const item = this.items[i];
        if (amount == this.maxAmount) {
          this.results = filteredItems;
          return;
        }
        if (item.name.toLowerCase().includes(this.search.toLowerCase())) {
          amount++;
          filteredItems.push(item);
        }
      }
      this.results = filteredItems;
      this.current = 0;
      this.error = false;
      return;
    },
    // v-bind:class="{'active': isActive(i)}"
    // enter() {
    //   this.selection = this.results[this.current];
    //   this.isOpen = false;
    // },
    // up() {
    //   if (this.current > 0) this.current--;
    // },
    // down() {
    //   if (this.current < this.results.length - 1) this.current++;
    // },
    //  isActive (index) {
    //   return index === this.current
    // },
  },
};
</script>

<style>
.autocomplete {
  z-index: 10;
  position: relative;
  width: 100%;
}
#SearchInput {
  width: 100%;
}

.openSuggestions {
  border-bottom-right-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}

.autocomplete-result {
  list-style: none;
  text-align: left;
  cursor: pointer;
  color: white;
  white-space: nowrap;
  background-color: #22262b;
  border-bottom: solid var(--dark);
}

.suggestions {
  background-color: transparent;
  height: 250px;
  width: 100%;
  overflow: auto;
  overflow-x: hidden;
  background-color: #22262b;
  position: absolute;
}

.autocomplete-result:hover {
  background-color: #4aae9b;
}
</style>
